import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IAcademicYear, IAcademicYears } from '../interfaces/academic-year';

@Injectable({
  providedIn: 'root',
})
export class AcademicYearService {
  constructor(private httpClient: HttpClient) {}

  createAcademicYear(url: string, academicYearForm: any): Observable<IAcademicYear> {
    return this.httpClient.post<IAcademicYear>(url, academicYearForm, {
      headers: { accept: '*/*' },
    }) as Observable<IAcademicYear>;
  }

  getAcademicYears(url: string, filters: any): Observable<IAcademicYears> {
    return this.httpClient.get<IAcademicYears>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IAcademicYears>;
  }

  editAcademicYear(url: string, editForm: any): Observable<IAcademicYear> {
    return this.httpClient.patch<IAcademicYear>(url, editForm, {
      headers: { accept: '*/*' },
    }) as Observable<IAcademicYear>;
  }

  getAcademicYearById(url: string): Observable<IAcademicYear> {
    return this.httpClient.get<IAcademicYear>(url, {
      headers: { accept: '*/*' },
    }) as Observable<IAcademicYear>;
  }
}
